import { LayerProps } from "react-map-gl/maplibre";
import { LineCategoryConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getLineCategoryStyle = (
	configs: LineCategoryConfigs,
): LayerProps[] => {
	const { symbolStyle, valueField, symbolValues } = configs;

	const styles: LayerProps[] = [];

	// Stroke
	if (symbolStyle?.stroke?.style === "solid") {
		styles.push({
			id: "solid-stroke-casing",
			type: "line",
			layout: {
				"line-cap": "round",
				"line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 0,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.stroke?.style === "dash") {
		styles.push(
			{
				id: "dash-stroke-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": "#000000",
					"line-width": (symbolStyle?.stroke?.width ?? 0) * 4,
					"line-dasharray": [
						symbolStyle?.stroke?.width ?? 0,
						symbolStyle?.stroke?.width ?? 0,
					],
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			},
			{
				id: "dash-stroke-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": symbolStyle?.stroke?.width ?? 0,
					"line-dasharray": [
						(symbolStyle?.stroke?.width ?? 0) * 4,
						(symbolStyle?.stroke?.width ?? 0) * 4,
					],
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			},
		);
	}

	if (symbolStyle?.stroke?.style === "dot") {
		const width = symbolStyle?.stroke?.width ?? 0;

		styles.push(
			{
				id: "dot-stroke-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": width,
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
			{
				id: "dot-stroke-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": width,
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
		);
	}

	// Fill
	if (symbolStyle?.fill?.fillType === "solid") {
		styles.push({
			id: "solid-fill-filling",
			type: "line",
			layout: {
				"line-cap": "round",
				"line-join": "round",
			},
			paint: {
				// @ts-ignore
				"line-color": [
					"match",
					["to-string", ["get", valueField!]],
					...symbolValues!.flatMap(({ value, symbol }) => [
						value!,
						symbol!.fill!.color!,
					]),
					"#ffffff",
				],
				"line-width": symbolStyle?.fill?.width ?? 0,
				"line-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.fill?.fillType === "dash") {
		styles.push(
			{
				id: "dash-fill-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": "#000000",
					"line-width": (symbolStyle?.fill?.width ?? 0) * 4,
					"line-dasharray": [
						symbolStyle?.fill?.width ?? 0,
						symbolStyle?.fill?.width ?? 0,
					],
					"line-opacity": symbolStyle?.fill?.opacity ?? 1,
				},
			},
			{
				id: "dash-fill-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					// @ts-ignore
					"line-color": [
						"match",
						["to-string", ["get", valueField!]],
						...symbolValues!.flatMap(({ value, symbol }) => [
							value!,
							symbol!.fill!.color!,
						]),
						"#ffffff",
					],
					"line-width": symbolStyle?.fill?.width ?? 0,
					"line-dasharray": [
						(symbolStyle?.fill?.width ?? 0) * 4,
						(symbolStyle?.fill?.width ?? 0) * 4,
					],
					"line-opacity": symbolStyle?.fill?.opacity ?? 1,
				},
			},
		);
	}

	if (symbolStyle?.fill?.fillType === "dot") {
		const width = symbolStyle?.fill?.width ?? 0;

		styles.push(
			{
				id: "dot-fill-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					// @ts-ignore
					"line-color": [
						"match",
						["to-string", ["get", valueField!]],
						...symbolValues!.flatMap(({ value, symbol }) => [
							value!,
							symbol!.fill!.color!,
						]),
						"#ffffff",
					],
					"line-width": width,
					"line-opacity": symbolStyle?.fill?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
			{
				id: "dot-fill-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": [
						"match",
						["to-string", ["get", valueField!]],
						...symbolValues!.flatMap(({ value, symbol }) => [
							value!,
							symbol!.fill!.color!,
						]),
						"#ffffff",
					],
					"line-width": width,
					"line-opacity": symbolStyle?.fill?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
		);
	}

	return styles;
};
